import { AxiosError } from 'axios'

import axios from '@/axios'
import { ENDPOINTS } from '@/constants/api'
import { errorHandler, extractResponse } from '@/services/api/utils'

export const getInfo = async (): Promise<any> => {
  try {
    return extractResponse(await axios.get(ENDPOINTS.INFO))
  } catch (err) {
    errorHandler(err as AxiosError)
  }
}
